document.addEventListener('DOMContentLoaded', () => {
  // --- Initialization ---
  initializeFastImageLoading();
  initializeMobileSwipe();
  initializeGridLayout();

  const hotspotButtons = document.querySelectorAll('.hotspot-btn');
  const modal = document.getElementById('hotspot-product-modal');
  const modalContent = modal?.querySelector('.hotspot-product-content');
  const modalWrapper = modal?.querySelector('.hotspot-modal-content');
  const closeBtn = modal?.querySelector('.hotspot-modal-close');
  const overlay = modal?.querySelector('.hotspot-modal-overlay');
  const galleryGrid = document.querySelector('.hotspot-gallery-grid');

  let isModalOpen = false;
  let currentHotspotButton = null;
  let scrollCloseEnabled = false; // Add flag to control scroll closing

  // --- Modal Positioning (from Script 1) ---
 function positionModalNearHotspot(hotspotBtn) {
  if (!hotspotBtn || !modalWrapper) return;

  const hotspotRect = hotspotBtn.getBoundingClientRect();
  const hotspotItem = hotspotBtn.closest('.hotspot-item');
  const itemRect = hotspotItem ? hotspotItem.getBoundingClientRect() : hotspotRect;

  const hotspotX = hotspotRect.left + hotspotRect.width / 2;
  const hotspotY = hotspotRect.top + hotspotRect.height / 2;

  const modalWidth = 280;
  const modalHeight = 140;

  // Small gap above hotspot
  const offsetY = 30;

  // Position: centered horizontally, above hotspot
  let modalLeft = hotspotX - modalWidth / 2;
  let modalTop = hotspotY - modalHeight - offsetY;
 
  modalLeft += 10;

  // Boundaries inside hotspot item
  const maxLeft = itemRect.right - modalWidth - 10;
  const minLeft = itemRect.left + 10;
  const minTop = itemRect.top + 10;

  // Clamp horizontally
  if (modalLeft < minLeft) modalLeft = minLeft;
  if (modalLeft > maxLeft) modalLeft = maxLeft;

  // If not enough space above, fallback below hotspot
  if (modalTop < minTop) {
    modalTop = hotspotY + offsetY;
  }

  // Final viewport check
  modalLeft = Math.max(20, Math.min(modalLeft, window.innerWidth - modalWidth - 20));
  modalTop = Math.max(20, Math.min(modalTop, window.innerHeight - modalHeight - 20));

  modalWrapper.style.position = 'fixed';
  modalWrapper.style.left = modalLeft + 'px';
  modalWrapper.style.top = modalTop + 'px';
  modalWrapper.style.transform = 'none';
  modalWrapper.style.margin = '0';
}

  // --- Product Data Cache ---
  const productCache = new Map();

  async function fetchProductDataWithCache(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error(`Failed to fetch product: ${response.statusText}`);
    const productData = await response.json();
    productCache.set(handle, productData);
    return productData;
  }

  // Preload product data
  function preloadProductData() {
    const visibleHotspots = document.querySelectorAll('.hotspot-btn[data-product-handle]');
    visibleHotspots.forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (handle && !productCache.has(handle)) {
        fetchProductDataWithCache(handle).catch(() => {});
      }
    });
  }
  setTimeout(preloadProductData, 1000);

  // --- Handle Hotspot Clicks ---
  hotspotButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const handle = btn.dataset.productHandle;
      if (!handle || !modal || !modalContent) {
        console.error('Missing required elements for product modal');
        return;
      }

      try {
        showLoadingState();
        modal.classList.remove('hidden');
        // document.body.style.overflow = 'hidden';
        isModalOpen = true;
        currentHotspotButton = btn;
        scrollCloseEnabled = false; // Disable scroll close initially

        positionModalNearHotspot(btn);

        const productData = await fetchProductDataWithCache(handle);
        displayProduct(productData);

        setTimeout(() => positionModalNearHotspot(btn), 100);
        
        // Enable scroll close after modal is fully opened and positioned
        setTimeout(() => {
          scrollCloseEnabled = true;
        }, 800); // Wait 800ms before enabling scroll close
        
      } catch (error) {
        console.error('Error loading product:', error);
        showErrorState();
      }
    });
  });

  // --- Display Product ---
  function displayProduct(product) {
    const html = `
      <div class="hotspot-product-card">
        <div class="product-image">
          <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
        </div>
        <div class="product-info">
          <h3 class="product-title">${product.title}</h3>
          <div class="product-price">
            ${formatPrice(product.price)}
            ${product.compare_at_price && product.compare_at_price > product.price ? 
              `<span class="compare-price">${formatPrice(product.compare_at_price)}</span>` : ''}
          </div>
          ${product.description ? `<div class="product-description">${truncateText(product.description, 150)}</div>` : ''}
          <div class="product-actions">
            <a href="/products/${product.handle}" class="btn-primary">View Product</a>
            ${product.available ? 
              `<button class="btn-secondary add-to-cart" data-variant-id="${product.variants[0].id}">Add to Cart</button>` :
              `<button class="btn-secondary" disabled>Sold Out</button>`}
          </div>
        </div>
      </div>
    `;
    modalContent.innerHTML = html;

    const addToCartBtn = modalContent.querySelector('.add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => handleAddToCart(addToCartBtn.dataset.variantId));
    }
  }

  // --- Add to Cart ---
  async function handleAddToCart(variantId) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (response.ok) {
        showNotification('Product added to cart!', 'success');
        setTimeout(hideModal, 1000);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      showNotification('Failed to add to cart. Please try again.', 'error');
    }
  }

  // --- Modal Controls ---
  function showLoadingState() {
    modalContent.innerHTML = `
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Loading product...</p>
      </div>
    `;
  }

  function showErrorState() {
    modalContent.innerHTML = `
      <div class="error-state">
        <p>Sorry, we couldn't load this product. Please try again.</p>
      </div>
    `;
  }

  function hideModal() {
    if (modal && isModalOpen) {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
      modalContent.innerHTML = '';
      isModalOpen = false;
      currentHotspotButton = null;
      scrollCloseEnabled = false; // Reset scroll close flag
      
      // Clear any pending scroll timeout
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
        scrollTimeout = null;
      }
      
      if (modalWrapper) {
        modalWrapper.style.position = '';
        modalWrapper.style.left = '';
        modalWrapper.style.top = '';
        modalWrapper.style.transform = 'translate(-50%, -50%)';
        modalWrapper.style.margin = '';
      }
    }
  }

  // --- Enhanced Modal Close Events ---
  
  // Close button
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      hideModal();
    });
  }
  
  // Overlay click (click outside)
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      e.stopPropagation();
      hideModal();
    });
  }
  
  // Click outside modal content
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        hideModal();
      }
    });
  }
  
  // Prevent modal content clicks from closing modal
  if (modalWrapper) {
    modalWrapper.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
  
  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isModalOpen) {
      e.preventDefault();
      hideModal();
    }
  });

  // --- Scroll to Close Modal (Fixed for Mobile) ---

  let initialTouchY = null;
  // --- Scroll to Close Modal ---
let scrollTimeout;
let lastScrollTime = 0;

function handleScroll() {
  if (!isModalOpen || !scrollCloseEnabled) return;

  const currentTime = Date.now();

  // Ignore rapid scrolls
  if (currentTime - lastScrollTime < 50) {
    lastScrollTime = currentTime;
    return;
  }
  lastScrollTime = currentTime;

  if (scrollTimeout) clearTimeout(scrollTimeout);

  // Close after scroll ends
  scrollTimeout = setTimeout(() => {
    if (isModalOpen && scrollCloseEnabled) {
      hideModal();
    }
  }, 200); // 200ms after scrolling stops
}

// ✅ Always listen to page scroll (works for both up/down)
window.addEventListener("scroll", handleScroll, { passive: true });
document.addEventListener("scroll", handleScroll, { passive: true });

// Keep gallery scroll detection too
if (galleryGrid) {
  galleryGrid.addEventListener("scroll", handleScroll, { passive: true });
}

  // Add scroll listeners with better mobile detection
  
  // Gallery scroll (works on both desktop and mobile)
  if (galleryGrid) {
    galleryGrid.addEventListener('scroll', handleScroll, { passive: true });
  }
  
  // Desktop scroll listeners
  if (window.innerWidth > 768) {
    window.addEventListener('scroll', handleScroll, { passive: true });
    document.addEventListener('scroll', handleScroll, { passive: true });
  }
  
  // Mobile touch events (improved detection)
  function handleTouchStart(e) {
    if (!isModalOpen || !scrollCloseEnabled) return;
    initialTouchY = e.touches[0].clientY;
  }
  
  function handleTouchMove(e) {
    if (!isModalOpen || !scrollCloseEnabled || initialTouchY === null) return;
    
    const currentY = e.touches[0].clientY;
    const deltaY = Math.abs(currentY - initialTouchY);
    
    // If touch movement is significant (more than 20px), treat as scroll
    if (deltaY > 20) {
      handleScroll(e);
    }
  }
  
  function handleTouchEnd() {
    initialTouchY = null;
  }
  
  // Add touch listeners for mobile
  document.addEventListener('touchstart', handleTouchStart, { passive: true });
  document.addEventListener('touchmove', handleTouchMove, { passive: true });
  document.addEventListener('touchend', handleTouchEnd, { passive: true });
  
  // Additional mobile scroll detection
  document.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('scroll', handleScroll, { passive: true });

  // --- Window Resize - Reposition Modal ---
  window.addEventListener('resize', () => {
    if (isModalOpen && currentHotspotButton) {
      // Temporarily disable scroll close during resize
      const wasScrollCloseEnabled = scrollCloseEnabled;
      scrollCloseEnabled = false;
      
      setTimeout(() => {
        positionModalNearHotspot(currentHotspotButton);
        scrollCloseEnabled = wasScrollCloseEnabled;
      }, 100);
    }
  });

  // --- Helpers ---
  function initializeMobileSwipe() {
    // Mobile swipe functionality
    const grid = document.querySelector('.hotspot-gallery-grid');
    if (!grid) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    grid.addEventListener('mousedown', (e) => {
      isDown = true;
      grid.classList.add('active');
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
    });

    grid.addEventListener('mouseleave', () => {
      isDown = false;
      grid.classList.remove('active');
    });

    grid.addEventListener('mouseup', () => {
      isDown = false;
      grid.classList.remove('active');
    });

    grid.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - grid.offsetLeft;
      const walk = (x - startX) * 2;
      grid.scrollLeft = scrollLeft - walk;
    });
  }

  function initializeFastImageLoading() {
    const images = document.querySelectorAll('.hotspot_image');
    
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => {
          img.classList.add('loaded');
        });
        img.addEventListener('error', () => {
          img.classList.add('loaded'); // Show even if error
        });
      }
    });
  }

  function initializeGridLayout() {
    const container = document.querySelector('.hotspot-gallery-container');
    const grid = document.querySelector('.hotspot-gallery-grid');
    
    if (!container || !grid) return;
    
    // Set grid gap from CSS variable
    const gapValue = getComputedStyle(document.documentElement).getPropertyValue('--grid-gap') || '8px';
    grid.style.gap = gapValue;
  }

 function formatPrice(cents) {
  return (cents / 100).toLocaleString('en-IN', { 
    style: 'currency', 
    currency: 'INR' 
  });
}
  function truncateText(text, maxLength) {
    return text.length <= maxLength ? text : text.substring(0, maxLength).trim() + '...';
  }
  
  function showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#4CAF50' : '#f44336'};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 10000;
      font-family: Arial, sans-serif;
    `;
    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 3000);
  }
});

// Update "View Product" to "Shop Now"
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".product-actions .btn-primary");
  buttons.forEach(btn => {
    if (btn.textContent.trim() === "View Product") {
      btn.textContent = "Shop Now";
    }
  });
});
